export const addClass = className => document.documentElement.classList.add(className);
export const removeClass = className => document.documentElement.classList.remove(className);
export const toggleClass = className => document.documentElement.classList.toggle(className);
export const containsClass = className => document.documentElement.classList.contains(className);
